<form>
  <section class="main-section">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Reports</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col">
        <div class="inner-box p-4">
          <h2>Reports</h2>

          <div class="row mt-4">

            <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #96D1FE;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" viewBox="0 0 16 16">
                        <path id="Icon_material-shopping-cart" data-name="Icon material-shopping-cart" d="M6.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,6.3,15.8ZM1.5,3V4.6H3.1l2.88,6.072L4.9,12.632a1.547,1.547,0,0,0-.2.768A1.6,1.6,0,0,0,6.3,15h9.6V13.4H6.636a.2.2,0,0,1-.2-.2l.024-.1.72-1.3h5.96a1.592,1.592,0,0,0,1.4-.824L17.4,5.784a.782.782,0,0,0,.1-.384.8.8,0,0,0-.8-.8H4.868L4.116,3ZM14.3,15.8a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,14.3,15.8Z" transform="translate(-1.5 -3)" fill="#fff"></path>
                      </svg>
                      Orders
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Order Detail'}">Order Detail</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #79E198;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 20.99 16.792">
                        <path id="Icon_awesome-shipping-fast" data-name="Icon awesome-shipping-fast" d="M20.465,11.545h-.525V8a1.574,1.574,0,0,0-.462-1.112L16.2,3.611a1.574,1.574,0,0,0-1.112-.462H13.644V1.574A1.575,1.575,0,0,0,12.069,0h-8.4A1.575,1.575,0,0,0,2.1,1.574V3.149H.262A.263.263,0,0,0,0,3.411v.525A.263.263,0,0,0,.262,4.2H9.183a.263.263,0,0,1,.262.262v.525a.263.263,0,0,1-.262.262H1.312a.263.263,0,0,0-.262.262v.525a.263.263,0,0,0,.262.262H8.134a.263.263,0,0,1,.262.262v.525a.263.263,0,0,1-.262.262H.262A.263.263,0,0,0,0,7.609v.525A.263.263,0,0,0,.262,8.4H7.084a.263.263,0,0,1,.262.262v.525a.263.263,0,0,1-.262.262H2.1v4.2a3.149,3.149,0,1,0,6.3,0h4.2a3.149,3.149,0,1,0,6.3,0h1.574a.526.526,0,0,0,.525-.525v-1.05A.526.526,0,0,0,20.465,11.545ZM5.248,15.218a1.574,1.574,0,1,1,1.574-1.574A1.575,1.575,0,0,1,5.248,15.218Zm10.5,0a1.574,1.574,0,1,1,1.574-1.574A1.575,1.575,0,0,1,15.743,15.218ZM18.366,8.4H13.644V4.723H15.09L18.366,8Z" fill="#fff"></path>
                      </svg>
                      Shipments
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button disabled class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Shipments'}">Shipments</button>
                      </div>
                      <div class="col-md-6">
                        <button disabled class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Shipment Cost'}">Shipments Costs</button>
                      </div>
                      <div class="col-md-6">
                        <button disabled class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Shipped products'}" style="text-overflow: ellipsis;">Shipments Products</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/shipmentExceptionReport" style="text-overflow: ellipsis;">Shipment Exception</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #F6B554;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 15.733 15.733">
                        <path id="Icon_awesome-box" data-name="Icon awesome-box" d="M15.656,5.673,14.1,1.008A1.471,1.471,0,0,0,12.7,0H8.358V5.9h7.335A1.4,1.4,0,0,0,15.656,5.673ZM7.375,0H3.03a1.471,1.471,0,0,0-1.4,1.008L.077,5.673A1.4,1.4,0,0,0,.04,5.9H7.375ZM0,6.883v7.375a1.475,1.475,0,0,0,1.475,1.475H14.258a1.475,1.475,0,0,0,1.475-1.475V6.883Z" fill="#fff"></path>
                      </svg>
                      Products
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Demand by SKU'}">Demand By SKU</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Product Sales'}">Product Sales</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Returned Products list'}">Returned Products List</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #FE9696;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 23.754 28.505">
                        <path id="Icon_map-accounting" data-name="Icon map-accounting" d="M24.979.72h-19A2.382,2.382,0,0,0,3.6,3.1V26.85a2.382,2.382,0,0,0,2.375,2.375h19a2.382,2.382,0,0,0,2.375-2.375V3.1A2.382,2.382,0,0,0,24.979.72ZM10.726,24.474a1.191,1.191,0,0,1-1.188,1.188H7.163a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188H9.539a1.191,1.191,0,0,1,1.188,1.188Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H7.163a1.191,1.191,0,0,1-1.188-1.188V19.13a1.191,1.191,0,0,1,1.188-1.188H9.539a1.191,1.191,0,0,1,1.188,1.188Zm0-4.751A1.191,1.191,0,0,1,9.539,16.16H7.163a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188H9.539a1.191,1.191,0,0,1,1.188,1.188Zm7.126,9.5a1.191,1.191,0,0,1-1.188,1.188H14.29A1.191,1.191,0,0,1,13.1,24.474v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H14.29A1.191,1.191,0,0,1,13.1,19.724V19.13a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H14.29A1.191,1.191,0,0,1,13.1,14.973v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm7.126,9.5a1.191,1.191,0,0,1-1.188,1.188H21.416a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H21.416a1.191,1.191,0,0,1-1.188-1.188V19.13a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-4.751a1.191,1.191,0,0,1-1.188,1.188H21.416a1.191,1.191,0,0,1-1.188-1.188v-.594a1.191,1.191,0,0,1,1.188-1.188h2.375a1.191,1.191,0,0,1,1.188,1.188v.594Zm0-5.345a1.191,1.191,0,0,1-1.188,1.188H7.163A1.191,1.191,0,0,1,5.975,9.628V4.877A1.191,1.191,0,0,1,7.163,3.689H23.791a1.191,1.191,0,0,1,1.188,1.188Z" transform="translate(-3.6 -0.72)" fill="#fff"></path>
                      </svg>
                      Accounting
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Account Snapshot'}">Accounting Snapshot</button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!--<div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #BD78F2;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 16 12.799">
                        <path id="Icon_awesome-warehouse" data-name="Icon awesome-warehouse" d="M12.6,8.8H3.41a.2.2,0,0,0-.2.2l0,1.2a.2.2,0,0,0,.2.2H12.6a.2.2,0,0,0,.2-.2V9A.2.2,0,0,0,12.6,8.8Zm0,2.4H3.4a.2.2,0,0,0-.2.2l0,1.2a.2.2,0,0,0,.2.2h9.2a.2.2,0,0,0,.2-.2V11.4A.2.2,0,0,0,12.6,11.2Zm0-4.8H3.415a.2.2,0,0,0-.2.2l0,1.2a.2.2,0,0,0,.2.2H12.6a.2.2,0,0,0,.2-.2V6.6A.2.2,0,0,0,12.6,6.4Zm2.663-3.475L8.46.094a1.2,1.2,0,0,0-.922,0L.738,2.926A1.2,1.2,0,0,0,0,4.034V12.6a.2.2,0,0,0,.2.2h2a.2.2,0,0,0,.2-.2V6.4a.809.809,0,0,1,.815-.8h9.57a.809.809,0,0,1,.815.8v6.2a.2.2,0,0,0,.2.2h2a.2.2,0,0,0,.2-.2V4.034A1.2,1.2,0,0,0,15.263,2.926Z" transform="translate(0 -0.002)" fill="#fff"></path>
                      </svg>
                      Inventory
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Low Stock Report'}">Low Stock</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Out Of Stock Report'}">Out Of Stock</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Stock Status Report'}">Stock Status</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Inventory Adjustments'}">Inventory Adjustments</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>-->



            <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #F65454;">
                      <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 0 12 16">
                        <path id="Icon_awesome-file-invoice" data-name="Icon awesome-file-invoice" d="M9,8H3v2H9Zm2.781-4.719L8.722.219A.749.749,0,0,0,8.191,0H8V4h4V3.809A.748.748,0,0,0,11.781,3.281ZM7,4.25V0H.75A.748.748,0,0,0,0,.75v14.5A.748.748,0,0,0,.75,16h10.5a.748.748,0,0,0,.75-.75V5H7.75A.752.752,0,0,1,7,4.25Zm-5-2A.25.25,0,0,1,2.25,2h2.5A.25.25,0,0,1,5,2.25v.5A.25.25,0,0,1,4.75,3H2.25A.25.25,0,0,1,2,2.75Zm0,2A.25.25,0,0,1,2.25,4h2.5A.25.25,0,0,1,5,4.25v.5A.25.25,0,0,1,4.75,5H2.25A.25.25,0,0,1,2,4.75Zm8,9.5a.25.25,0,0,1-.25.25H7.25A.25.25,0,0,1,7,13.75v-.5A.25.25,0,0,1,7.25,13h2.5a.25.25,0,0,1,.25.25ZM10,7.5v3a.5.5,0,0,1-.5.5h-7a.5.5,0,0,1-.5-.5v-3A.5.5,0,0,1,2.5,7h7A.5.5,0,0,1,10,7.5Z" fill="#fff"></path>
                      </svg>
                      Other Reports
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Customer details'}">Customer Details</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Order all details'}">Order All Details</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Products'}">Products</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

        <!--   <div class="col-md-6">
              <div class="report-box">
                <div class="row">
                  <div class="col-md-auto p-0">
                    <div class="icon-box" style="background-color: #a04545;">
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="30" height="30" viewBox="0 0 350 350" xml:space="preserve"><defs></defs>
                        <g id="icon" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(-1.9444444444444287 -1.9444444444444287) scale(3.89 3.89)" >
	                       <path d="M 52.355 46.798 v 13.679 h 16.865 V 46.798 H 52.355 z M 66.221 57.477 H 55.355 v -7.679 h 3.933 v 3.84 h 3 v -3.84 h 3.933 V 57.477 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                          <path d="M 84 74.617 V 35.949 v -8.965 L 45 12.28 L 6 26.984 v 8.965 v 38.668 H 0 v 3 h 90 v -3 H 84 z M 9 35.949 v -6.89 l 36 -13.573 l 36 13.573 v 6.89 v 38.668 h -5.03 v -43.35 H 14.03 v 43.35 H 9 V 35.949 z M 62.288 70.638 v -3.84 h 3.933 v 7.679 H 55.355 v -7.679 h 3.933 v 3.84 H 62.288 z M 52.355 63.798 v 10.819 h -3.135 V 63.798 H 32.355 v 10.819 H 17.208 V 39.139 h 55.584 v 35.478 h -3.571 V 63.798 H 52.355 z M 42.288 70.638 v -3.84 h 3.933 v 7.679 H 35.355 v -7.679 h 3.933 v 3.84 H 42.288 z M 72.792 36.139 H 17.208 v -1.694 h 55.584 V 36.139 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                          </g>
                       </svg>
                      Warehouses
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="row">
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Warehouse'}">Warehouse</button>
                      </div>
                      <div class="col-md-6">
                        <button class="btn btn-cancel-prime btn-block" routerLink="/admin/reportDetails" [queryParams]="{type: 'Report'}">Report</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

-->
          </div>
        </div>
      </div>
    </div>



    <!--
    <div class="row">
      <div class="col-6">
        <div class="d-block  mt-2" *ngFor="let role of permissions | slice:0: sliceUPto(permissions?.length);let i=index;">
          <div class="inner-box">
            <h2 class="text-black">{{role.name}}</h2>
            <div class="row" >
              <div class="col-6">
                <div *ngFor="let d of role.actions">
                  <button type="submit" routerLink="/admin/reportDetails" [queryParams]="{type: d.name}" class="btn b-change mb-2 w-300">{{d.name}}</button>
                </div>
              </div>
              <div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="d-block  mt-2" *ngFor="let role of permissions | slice:sliceUPto(permissions?.length):permissions?.length;let i = index;">
          <div class="inner-box">
            <h2 class="text-black">{{role.name}}</h2>
            <div class="row" >
              <div class="col-6">
                <div *ngFor="let d of role.actions">
                  <button type="submit" routerLink="/admin/reportDetails" [queryParams]="{type: d.name}" [disabled]="d.name == 'Shipments' || d.name == 'Shipment Cost' || d.name == 'Shipped products'"  class="btn b-change mb-2 w-300">{{d.name}}</button>
                </div>
              </div>
              <div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
  </section>
</form>

